( function () {
	const tooltip = document.createElement( 'div' );
	Object.assign( tooltip.style, {
		position: 'fixed',
		zIndex: '99999',
		background: 'rgba(0,0,0,0.88)',
		color: '#fff',
		padding: '0.45rem 0.7rem',
		borderRadius: '5px',
		fontSize: '0.85rem',
		lineHeight: '1.45',
		maxWidth: '280px',
		pointerEvents: 'none',
		display: 'none',
		boxShadow: '0 4px 14px rgba(0,0,0,0.35)',
		wordBreak: 'break-word',
		fontWeight: '600',
	} );
	document.body.appendChild( tooltip );

	function isClamped( el ) {
		return el.scrollHeight > el.clientHeight + 1;
	}

	function position( e ) {
		const pad = 12;
		const tw = tooltip.offsetWidth;
		const th = tooltip.offsetHeight;
		let x = e.clientX + pad;
		let y = e.clientY - th / 2;
		if ( x + tw > window.innerWidth - pad ) x = e.clientX - tw - pad;
		if ( y < pad ) y = pad;
		if ( y + th > window.innerHeight - pad ) y = window.innerHeight - th - pad;
		tooltip.style.left = x + 'px';
		tooltip.style.top = y + 'px';
	}

	document.querySelectorAll( '.notice-card-title' ).forEach( function ( el ) {
		el.addEventListener( 'mouseenter', function ( e ) {
			if ( ! isClamped( el ) ) return;
			tooltip.textContent = el.getAttribute( 'title' ) || el.textContent.trim();
			tooltip.style.display = 'block';
			position( e );
		} );
		el.addEventListener( 'mousemove', function ( e ) {
			if ( tooltip.style.display === 'none' ) return;
			position( e );
		} );
		el.addEventListener( 'mouseleave', function () {
			tooltip.style.display = 'none';
		} );
	} );
} )();
